/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Group_Type_TranscriptionInputs */

const en_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const fr_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkription`)
};

const it_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрипция`)
};

const es_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录`)
};

const ja_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写`)
};

const hi_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_merge_event_group_group_type_transcription = /** @type {(inputs: Merge_Event_Group_Group_Type_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription" |
*
* @param {Merge_Event_Group_Group_Type_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_group_type_transcription = /** @type {((inputs?: Merge_Event_Group_Group_Type_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Group_Type_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_group_type_transcription(inputs)
	if (locale === "de") return de_merge_event_group_group_type_transcription(inputs)
	if (locale === "it") return it_merge_event_group_group_type_transcription(inputs)
	if (locale === "ru") return ru_merge_event_group_group_type_transcription(inputs)
	if (locale === "es") return es_merge_event_group_group_type_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_group_type_transcription(inputs)
	if (locale === "ja") return ja_merge_event_group_group_type_transcription(inputs)
	if (locale === "hi") return hi_merge_event_group_group_type_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_group_type_transcription(inputs)
	return en_merge_event_group_group_type_transcription(inputs)
});